import { Droppable } from '@hello-pangea/dnd';
import { Control, FieldArrayWithId, UseFormRegister } from 'react-hook-form';

import { type InquiryForm } from '../../../models/Inquiry/Inquiry';
import FormContentItem from './FormContentItem';

interface Props {
  droppableId: string
  fields: Array<FieldArrayWithId<InquiryForm, 'definition', 'id'>>
  register: UseFormRegister<InquiryForm>
  control: Control<InquiryForm, any>
  onRemove: (id: number) => void
  disabled: boolean
  sideContent?: JSX.Element
}

export default function FormContent({
  droppableId,
  fields,
  control,
  register,
  onRemove,
  disabled,
  sideContent = null,
}: Props): JSX.Element {
  return (
    <>
      <div className="fw-bold mb-1">
        <span>&lt;Display items&gt;</span>
        <span className="label-required mx-2">Required</span>

        {sideContent && (
          <span className="float-end">
            {sideContent}
          </span>
        )}
      </div>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`webdb-list-viewitems flex-fill ${snapshot.isDraggingOver ? 'bg-light' : ''}`}
          >
            {/* When items are empty */}
            {
              fields.length === 0 && (
                <div className="list-group gap-1 justify-content-center user-select-none h-100">
                  <div className="align-self-center opacity-50">Drag and drop items</div>
                </div>
              )
            }
            {/* When items exist */}
            <div className="list-group gap-1 justify-content-center">
            {fields?.map((item, index) => (
              <FormContentItem
                key={item.uuid}
                item={item}
                index={index}
                register={register}
                control={control}
                onRemove={onRemove}
                disabled={disabled}
              />
            ))}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
}
